import BaseTemplate from "../src/layouts/BaseTemplate";
import EardView from "../src/view/_public/EardView";

export default function Eard() {
  return (
    <BaseTemplate
      title="Education and Advocacy Department"
      body={<EardView />}
    />
  );
}
